__turbopack_context__.v({
  "container": "niceToHaveSection-module-scss-module__u8GP6W__container",
  "content": "niceToHaveSection-module-scss-module__u8GP6W__content",
  "heading": "niceToHaveSection-module-scss-module__u8GP6W__heading",
  "language": "niceToHaveSection-module-scss-module__u8GP6W__language",
  "list": "niceToHaveSection-module-scss-module__u8GP6W__list",
  "separator": "niceToHaveSection-module-scss-module__u8GP6W__separator",
});
